<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <v-form
        v-model="isValidInvitation"
        @submit.prevent="inviteUser()"
      >
        <v-text-field
          v-model.trim="userEmail"
          solo
          :rules="[ isEmail ]"
          label="Invite members"
          hint="Enter an email address"
          append-icon="person_add"
          @click:append="inviteUser()"
        />
      </v-form>
    </v-flex>

    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="usersAndInvited"
        :sort-by="sortBy"
        class="elevation-2"
      >
        <template v-slot:item.picture="{ item }">
          <v-badge
            color="accent"
            :value="item.id === $currentUser.id"
            overlap
          >
            <span
              slot="badge"
              v-t="'me'"
            />

            <pa-user-avatar
              type="avatar"
              :user-id="item.id"
              :size="36"
            />
          </v-badge>
        </template>

        <template v-slot:item.id="{ item }">
          <span v-if="item.id">{{ item.id }}</span>
          <v-chip
            v-else
            label
          >
            INVITED
          </v-chip>
        </template>

        <template
          v-if="false"
          v-slot:item.action="{ }"
        >
          <v-btn
            icon
            @click="removeUserFromOrg()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import { db } from '@/plugins/stitch'
import { isEmail } from '@/utils/rules'

export default {
  data () {
    return {
      headers: [
        { text: null, sortable: false, value: 'picture' },
        { text: 'Name', value: 'profile.displayName' },
        { text: 'Job Title', value: 'profile.jobTitle' },
        { text: 'E-Mail', value: 'email' },
        { text: 'ID', sortable: false, value: 'id' },
        { text: null, sortable: false, value: 'action' }
      ],
      isValidInvitation: false,
      sortBy: [ 'profile.displayName', 'email' ],
      userEmail: null,
      users: [],
      usersAndInvited: []
    }
  },
  computed: {
    ...mapGetters([ 'getUserById' ]),
    ...mapState('organizations', [ 'allRoles' ])
  },
  async mounted () {
    this.users = this.$currentOrganization.users.map(id => this.getUserById(id))

    this.usersAndInvited = await db
      .collection('invitations')
      .find({ organization: this.$currentOrganization.id })
      .toArray()

    this.usersAndInvited = [ ...this.usersAndInvited, ...this.users ]
  },
  methods: {
    isEmail,
    inviteUser () {
      if (!this.userEmail || !this.isValidInvitation) { return }

      const data = {
        email: this.userEmail.toLowerCase(),
        organization: this.$currentOrganization.id,
        createdBy: this.$currentUser.id
      }

      db
        .collection('invitations')
        .insertOne(data)
        .then(() => {
          this.$notify(`Invitation sent to ${this.userEmail}`)
          this.userEmail = null
          this.usersAndInvited.push(data)
        })
        .catch(err => {
          this.$notifyError(`Error sending invitation`, err)
          this.userEmail = null
        })
    }
  }
}
</script>
